import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../modules/auth/store';

import { authRoutes } from '../modules/auth/routes';
import { companyRoutes } from '../modules/company/routes';
import { errorRoutes } from '../router/errorRoutes';
import { groupRoutes } from '../modules/group/routes';
import { licenseRoutes } from '../modules/license/routes';
import { permissionRoutes } from '../modules/permission/routes';
import { selectionRoutes } from '../router/selectionRoutes';
import { userRoutes } from '../modules/user/routes';
// PHA routes
import { phaRoutes } from '../product/pha/routes';
//AMS routes
import { amsRoutes } from '../product/ams/routes';

import App from '@/App.vue';
import { ssoRoutes } from '@/modules/sso/routes';

const routes = [
    {
        path: '/',
        name: 'app',
        component: App,
        children: [
            // This is the default landing page for all the users who dont have access to dashboards or so on
            // {
            //     path: '',
            //     name: 'Landing',
            //     exact: true,
            //     component: () => import('@/modules/landing/views/Landing.vue'),
            //     meta: {
            //         breadcrumb: [{ parent: 'Favorites', label: { label: 'Dashboard', routerLink: '/' } }],
            //     },
            // },
            ...companyRoutes,
            {
                path: 'group',
                children: groupRoutes,
            },
            {
                path: 'license',
                children: licenseRoutes,
            },
            {
                path: 'permission',
                children: permissionRoutes,
            },
            {
                path: 'user',
                children: userRoutes,
            },
            ...phaRoutes,
            ...amsRoutes,
        ],
    },
    ...selectionRoutes,
    {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/modules/auth/views/Login.vue'),
        beforeEnter: async () => {
            const authStore = useAuthStore();
            await authStore.logout(); // Trigger the logout action from the store
        },
    },
    ...authRoutes,
    ...ssoRoutes,
    ...errorRoutes,
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    },
});

// route guards for checking conditions before routing users to certain routes
router.beforeEach((to, from, next) => {

    const auth = useAuthStore();
    const checkToken = auth.token;
    const companyId = auth.getLoggedUserCompanyId;
    const product = auth.selectedProduct;

    if (to.name === 'AuthCallback') {
        next();
        return;
    }


    // Check if the user has a token but is not valid.
    if (!checkToken && to.name !== 'Login'  && to.name !== 'ForgotPassword'  && to.name !== 'SetPassword' ) {
        next({ name: 'Login' });
    } else {
        if (checkToken && product && to.name !== 'ProductSelect' && !companyId && to.name !== 'CompanySelect' && to.name !== 'Logout' && to.name !== 'Login') {
            // Users without the company id (aka god) must choose a company.
            next({ name: 'CompanySelect' });
        } else if (to.path === '/' && to.name === 'app' && product === 'AMS') {
            // redirect to home
            next({ name: 'Home' });
        } else {
            next();
        }

    }


    /*
    console.log('@@@@ Here', to.name)
    const auth = useAuthStore();
    // const loggedUser = auth.loggedUser;
    const checkToken = auth.token;
    // list of products user have access to
    const products = auth.productList;
    // product selected by user
    const product = auth.selectedProduct;
    const companyId = auth.getLoggedUserCompanyId;
    // extract the permission sets the logged user has
    const userPermissions = auth.getUserPermissions;
    // lists out the permissions required to access that router
    const permissionsRequired = to?.meta?.permissions;
    // check if the requested route is godOnly or not
    const godOnly = to?.meta?.godOnly;
    // Check if the user has a token but is not valid
    if (!checkToken && to.name !== 'Login'  && to.name !== 'ForgotPassword'  && to.name !== 'SetPassword' ) {
        console.log('@@@@ not Login')
        next({ name: 'Login' });
    }
    // if user have token and multiple access to different products but product is not yet selected
    else if (checkToken && !product && products.length && to.name !== 'ProductSelect') {
        console.log('@@@@ ProductSelect')
        next({ name: 'ProductSelect' });
    }
    // if user have token, and a product is selected but company is not selected yet
    // this scenario is especially for root users because by default company is to be selected manually in the begining
    else if (checkToken && product && to.name !== 'ProductSelect' && !companyId && to.name !== 'CompanySelect' && to.name !== 'Logout' && to.name !== 'Login') {
        console.log('@@@@ ProductSelect')
        next({ name: 'CompanySelect' });
    }
    // Default home page or dashboard page redirection based on active product selected
    else if (to.path === '/' && to.name === 'app' && product === 'AMS') {
        console.log('@@@@ Home')
        next({ name: 'Home' });
    } // if this is a godOnly route then make sure the logged user is a god user before giving him/her access
    else if (godOnly) {
        // if the logged user is not a god user then dont give him/her access, else give access
        if (!auth.isGodUser) {
            console.log('@@@@ Access')
            next({ name: 'Access' });
        }
    }
    // if the route has permissionsRequired then checks if user have the required permission to access
    else if (permissionsRequired && permissionsRequired?.length > 0) {
        // check if all the permissionsRequired are present in the userPermissions
        if (!permissionsRequired.every((item) => userPermissions.includes(item))) {
            console.log('@@@@ Access 2')
            next({ name: 'Access' });
        }
        //next();
    } else {
        next();
    }*/
});

export default router;
